import {
  responsiveMediaFragment
} from './mediaFragments.gql'
import {
  localeFragment,
  internalLinkFragment,
  linkBlock
} from "./fragments.gql"

export default `query MainNavigationQuery($locale: SiteLocale) {
  mainNavigation(${localeFragment}) {
    mainNavigationItems {
      ... on MainNavigationButtonRecord {
        id
        _modelApiKey
        buttonText
        link {
          ${linkBlock}
        }
        gradient
        nestedItemsLayout
        nestedItems {
          ... on MainNavigationButtonRecord {
            id
            _modelApiKey
            buttonText
            link {
              ${linkBlock}
            }
            gradient
            nestedItems {
              ... on MainNavigationLinkRecord {
                id
                _modelApiKey
                linkText
                internalLink {
                  ${internalLinkFragment}
                }
                internalLinkQueryParams
              }
            }
          }
          ... on MainNavigationLinkRecord {
            id
            _modelApiKey
            linkText
            internalLink {
              ${internalLinkFragment}
            }
            gradient
            internalLinkQueryParams
            ${responsiveMediaFragment('logo', '{ w: 200 }')}
          }
          ... on MainNavigationImageCardRecord {
            id
            _modelApiKey
            ${responsiveMediaFragment('image', '{ w: 200 }')}
            linkText
            internalLink {
              ${internalLinkFragment}
            }
            internalLinkQueryParams
            productSku
          }
        }
      }
      ... on MainNavigationLinkRecord {
        id
        _modelApiKey
        linkText
        internalLink {
          ${internalLinkFragment}
        }
        gradient
        internalLinkQueryParams
      }
    }
    pagesWithBlackNavLinks {
      ${linkBlock}
    }
  }
}`
